// **************************************************
// Add content ID to first element after breadcrumbs
// **************************************************

window.addEventListener('DOMContentLoaded', () => {
  const mainDiv = document.querySelector('main');
  if (mainDiv) {
    const item = document.querySelector('main > *:first-of-type');
    const heroModule = mainDiv.querySelector('.sc-hero-module');

    if (item === heroModule) {
      item.nextElementSibling.setAttribute('id', 'content');
    } else {
      item.setAttribute('id', 'content');
    }
  }

  const wcagBtn = document.querySelector('#pojo-a11y-toolbar');
  const wcagSkipBtn = document.querySelector('#pojo-a11y-skip-content');
  wcagSkipBtn?.setAttribute('tabIndex', '0');

  if (wcagBtn) {
    setTimeout(() => {
      document.body.append(wcagBtn);
    }, 200);
  }

  if (windowWidth() < breakpointMd) {
    document.querySelectorAll('body [inert]').forEach((el) => el.removeAttribute('inert'));
  }

  // Scroll To Top
  const firstTopNavLink = document.querySelector('.site-header__top-nav-link');

  firstTopNavLink?.addEventListener('focus', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
});
